<template>
  <div class="grid gap-4 grid-cols-1 md:grid-cols-3 lg:grid-cols-4">
    <slot></slot>
  </div>
</template>

<script>
export default {
  name: "Grid"
}
</script>